export const HELP_CENTER_PAGE_BG = '#F5F5F5';
